import { render, staticRenderFns } from "./cadastro-cliente.vue?vue&type=template&id=0299c2dc"
import script from "./cadastro-cliente.vue?vue&type=script&lang=js"
export * from "./cadastro-cliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports